import Button from 'components/Button';
import classNames from 'styles/utils/classNames';

interface Props {
  onClick: () => void;
  /** Facets currently narrowing results; shown as a brand count badge when > 0. */
  activeCount?: number;
  /** From lg, when the desktop header holds a facet the mobile sheet counts (location). */
  desktopActiveCount?: number;
  /** From lg: `outlined` = 42px bordered (home feed), `floating` = 40px white with
   *  a drop shadow (/find header, Figma "Round/Floating/White"). */
  desktopStyle?: 'outlined' | 'floating';
}

const DESKTOP_STYLE = {
  outlined:
    'lg:h-[2.625rem] lg:w-[2.625rem] lg:border lg:border-color-border-hover-lightmode lg:dark:border-color-border-hover-darkmode',
  floating: 'lg:h-10 lg:w-10 lg:border-0 lg:shadow-fab',
} as const;

/** The round "Filters" trigger beside the For you switch (Figma "Round/Heart"). */
export default function FiltersButton({
  onClick,
  activeCount = 0,
  desktopActiveCount = activeCount,
  desktopStyle = 'outlined',
}: Props) {
  const badgeClass =
    'typography-product-chips-filters pointer-events-none absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-color-brand-primary px-1 text-white';
  return (
    <div className="relative shrink-0">
      <Button
        variant="secondary"
        size="icon"
        iconLeft={
          <img
            src="/images/app/filter-colored.svg"
            alt=""
            className="h-4 w-4 max-lg:h-3.5 max-lg:w-3.5"
          />
        }
        className={classNames(
          'rounded-full max-lg:h-8 max-lg:w-8 max-lg:border-0 max-lg:shadow-[0px_2px_4px_0px_rgba(0,0,0,0.1),0px_1px_1px_0px_rgba(0,0,0,0.06)]',
          DESKTOP_STYLE[desktopStyle],
        )}
        onClick={onClick}
        aria-label={activeCount ? `Filters (${activeCount} active)` : 'Filters'}
      />
      {activeCount > 0 && (
        <span className={classNames(badgeClass, 'lg:hidden')}>{activeCount}</span>
      )}
      {desktopActiveCount > 0 && (
        <span className={classNames(badgeClass, 'max-lg:hidden')}>{desktopActiveCount}</span>
      )}
    </div>
  );
}
